
export class Message {

	constructor(content) {
		this.content = content;

		let closeIcon = `${exports.resourcePath}/icons/close.svg`;

		this.element = $(`
			<div class="potree_message">
				<span name="content_container" class="potree_message_content"></span>
				<button name="close" class="potree_message_close" aria-label="Zamknij">
					<img src="${closeIcon}" class="potree_message_close_icon" alt="Zamknij">
				</button>
			</div>`);

		this.elClose = this.element.find("button[name=close]");

		this.elContainer = this.element.find("span[name=content_container]");

		if (typeof content === "string") {
			this.elContainer.append($(`<span>${content}</span>`));
		} else {
			this.elContainer.append(content);
		}

	}

	setMessage(content) {
		this.elContainer.empty();
		if (typeof content === "string") {
			this.elContainer.append($(`<span>${content}</span>`));
		} else {
			this.elContainer.append(content);
		}
	}

}